function zeroPad (number) {
  let s = '' + number
  return (s.length < 2 ? '0' : '') + s
}
function unZeroPad (s) {
  return s.startsWith('0') ? s.substr(1, 1) : s
}

module.exports = {
  datetimeToDate: (date) => {
    if (date && date.length >= 10) {
      return date.substr(0, 10)
    }
    return ''
  },
  datetimeToDateDanish: (date) => {
    if (date && date.length >= 10) {
      return date.substr(8, 2) + '-' + date.substr(5, 2) + '-' + date.substr(0, 4)
    }
    return ''
  },
  datetimeToTime: (date) => {
    if (date && date.length >= 16) {
      return date.substr(11, 5)
    }
    return ''
  },
  shortDatetime: (datetime) => {
    /* Converts from '2019-08-16 08:56:30' to '16/8 08:56:30' */
    if (datetime && datetime.length === 19) {
      let month = unZeroPad(datetime.substr(5, 2))
      let day = unZeroPad(datetime.substr(8, 2))
      return day + '/' + month + ' ' + datetime.substr(11)
    }
    return ''
  },
  extraShortDatetime: (datetime) => {
    /* Converts from '2019-08-16 08:56:30' to '08:56:30' */
    if (datetime && datetime.length === 19) {
      return datetime.substr(11)
    }
    return ''
  },
  datetimeToString: (date) => {
    if (date) {
      let s = date.getFullYear() + '-' + (zeroPad(date.getMonth() + 1)) + '-' + zeroPad(date.getDate()) +
        ' ' + zeroPad(date.getHours()) + ':' + zeroPad(date.getMinutes()) + ':' + zeroPad(date.getSeconds())
      return s
    }
    return ''
  },
  timeStringToDate: (str) => {
    /* yyyy-MM-dd HH:mm:ss */
    if (str && str.length >= 10) {
      let date = new Date()
      date.setFullYear(str.substr(0, 4))
      date.setMonth(str.substr(5, 2) - 1)
      date.setDate(str.substr(8, 2))
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      if (str.length >= 13) {
        date.setHours(str.substr(11, 2))
      }
      if (str.length >= 16) {
        date.setMinutes(str.substr(14, 2))
      }
      if (str.length >= 19) {
        date.setSeconds(str.substr(17, 2))
      }
      return date
    }
    return null
  },
  minutesToDate: (date) => {
    if (!date) {
      return null
    }
    let now = new Date()
    let millis = date.getTime() - now.getTime()
    return millis / 1000 / 60
  },
  ageInMinutes: (date) => {
    return Math.round((new Date().getTime() - date.getTime()) / (1000 * 60))
  },
  ageInHours: (date) => {
    return Math.round((new Date().getTime() - date.getTime()) / (1000 * 60 * 60))
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/dateutil.js